// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"223":"54e13a01","371":"b519dc23"}[chunkId] + ".css";
};